import { render, staticRenderFns } from "./BrowseCourse.vue?vue&type=template&id=25a628d4&scoped=true&"
import script from "./BrowseCourse.vue?vue&type=script&lang=js&"
export * from "./BrowseCourse.vue?vue&type=script&lang=js&"
import style0 from "./BrowseCourse.vue?vue&type=style&index=0&id=25a628d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a628d4",
  null
  
)

export default component.exports